import React from "react";
import classNames from "classnames";
import { TextInputProps } from "./types";
import styles from "./text-input.module.scss";

export const TextInput = ({
    type = "text",
    value,
    onBlur,
    onChange,
    placeholder,
    disabled,
    id,
    maxLength,
    className,
    containerClassName
}: TextInputProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!onChange) return;
        const val = e.target.value;
        if (type === "number") {
            const digits = val.replace(/\D/g, "");
            onChange(digits);
            return;
        }
        onChange(val);
    };

    return (
        <div className={classNames(styles["text-input"], containerClassName)}>
            <input
                id={id}
                className={classNames(styles["text-input__input"], className)}
                type={type === "number" ? "text" : type}
                inputMode={type === "number" ? "numeric" : undefined}
                placeholder={placeholder}
                disabled={disabled}
                value={value ?? ""}
                onBlur={onBlur}
                onChange={handleChange}
                maxLength={maxLength}
            />
        </div>
    );
};